export default {"src":"/_next/static/media/residential7.08d66f28.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};